
(() => {
  if (window.__zhBrandCarouselV22) return;
  window.__zhBrandCarouselV22 = true;

  function initCarousel(root = document) {
    root.querySelectorAll('[data-zh-brand-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';

      const track = carousel.querySelector('[data-zh-brand-track]');
      const prev = carousel.querySelector('[data-zh-brand-prev]');
      const next = carousel.querySelector('[data-zh-brand-next]');
      if (!track) return;

      const step = () => {
        const first = track.querySelector('.zh-brand-carousel__item');
        if (!first) return Math.max(180, track.clientWidth * .75);
        const gap = parseFloat(getComputedStyle(track).gap || '24') || 24;
        return first.getBoundingClientRect().width + gap;
      };

      const move = (direction) => {
        const max = track.scrollWidth - track.clientWidth;
        if (direction > 0 && track.scrollLeft >= max - 8) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && track.scrollLeft <= 8) {
          track.scrollTo({ left: max, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step() * direction, behavior: 'smooth' });
        }
      };

      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));

      let timer = setInterval(() => move(1), 2800);

      carousel.addEventListener('mouseenter', () => clearInterval(timer));
      carousel.addEventListener('mouseleave', () => {
        clearInterval(timer);
        timer = setInterval(() => move(1), 2800);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCarousel());
  } else {
    initCarousel();
  }

  document.addEventListener('shopify:section:load', (e) => initCarousel(e.target));
})();
